export default __webpack_public_path__ + "static/media/Icon feather-arrow-right-circle-2.617d47d1.svg";